var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": "title",
    "aria-describedby": "desc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "layer1",
    fill: "#202020",
    stroke: "#202020",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M6 2l52 30L6 62V2z",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  })));
}

export default __webpack_public_path__ + "static/media/arrowIcon.88e44f15.svg";
export { SvgArrowIcon as ReactComponent };